//const ajaxPath = "http://localhost/halya/ajax_query.php";
const ajaxPath = "https://www.vetsnz.ru/halya/ajax_query.php";
export {ajaxPath};